/**
 * Pixels to subtract so anchored content clears the sticky marketing header (toolbar + breathing room).
 */
export const MARKETING_HEADER_SCROLL_OFFSET_PX = 88;

/**
 * Scrolls to an element by id, offset upward so it sits below the sticky header.
 *
 * @param {string} id - DOM id (without `#`).
 * @param {"smooth" | "instant"} [behavior="smooth"] - Scroll behavior.
 * @returns {void}
 */
export function scrollToAnchorBelowHeader(id, behavior = "smooth") {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - MARKETING_HEADER_SCROLL_OFFSET_PX;
  window.scrollTo({ top: Math.max(0, top), behavior });
}
